import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { API } from '../utils/helpers';
import MarkdownRenderer from '../components/MarkdownRenderer';
import { ShareButton } from '../components/ShareComponents';

export default function NumerologyPage() {
  const [birthDate, setBirthDate] = useState('');
  const [name, setName] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const calculate = async () => {
    if (!birthDate) { toast.error('Ingresa tu fecha de nacimiento'); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/numerology/life-path`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ birth_date: birthDate, name })
      });
      setResult(await res.json());
    } catch (e) { toast.error('Error al calcular'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl font-bold gold-text text-center mb-4" data-testid="numerology-title">Numerologia</h1>
        <p className="text-[var(--text-muted)] text-center mb-8">Descubre el poder de los numeros en tu vida</p>
        <div className="glass-card p-8 max-w-xl mx-auto mb-8">
          <div className="space-y-4 mb-6">
            <div>
              <label className="block text-sm text-[var(--text-muted)] mb-2">Fecha de Nacimiento *</label>
              <input type="date" value={birthDate} onChange={e => setBirthDate(e.target.value)} className="mystic-input" data-testid="numerology-date-input" />
            </div>
            <div>
              <label className="block text-sm text-[var(--text-muted)] mb-2">Nombre Completo (opcional)</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre completo" className="mystic-input" data-testid="numerology-name-input" />
            </div>
          </div>
          <button onClick={calculate} disabled={loading} className="btn-gold w-full flex items-center justify-center gap-2" data-testid="calculate-numerology-btn">
            {loading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                <span>Calculando...</span>
              </>
            ) : 'Calcular Mi Numero'}
          </button>
        </div>
        {result && !loading && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="glass-card p-8">
            <div className="flex flex-col sm:flex-row items-center gap-6 mb-6">
              <div className="w-24 h-24 rounded-full flex items-center justify-center glow-gold" style={{ background: 'linear-gradient(135deg, var(--gold-dim), var(--gold))' }}>
                <span className="text-4xl font-bold" style={{ color: 'var(--void)' }}>{result.life_path}</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold gold-text">Numero de Camino de Vida</h3>
                {result.name_number && <p className="text-[var(--text-muted)]">Numero del Nombre: <span className="text-purple-400">{result.name_number}</span></p>}
              </div>
            </div>
            <MarkdownRenderer content={result.interpretation} className="text-[var(--text-secondary)]" data-testid="numerology-result" />
            
            {/* Share Button */}
            <div className="flex justify-end mt-6 pt-4 border-t border-gold-300/10">
              <ShareButton 
                content={{
                  type: 'numerology',
                  life_path: result.life_path,
                  name_number: result.name_number,
                  interpretation: result.interpretation?.substring(0, 200)
                }}
                title={`Mi número de camino de vida es ${result.life_path}`}
              />
            </div>
          </motion.div>
        )}
        <div className="mt-12 grid sm:grid-cols-3 gap-6">
          {[
            { num: '1-9', title: 'Numeros Base', desc: 'Los fundamentos de la numerologia' },
            { num: '11', title: 'Maestro 11', desc: 'Intuicion y espiritualidad elevada' },
            { num: '22', title: 'Maestro 22', desc: 'Constructor de suenos' },
          ].map((item, i) => (
            <div key={i} className="glass-card p-6 text-center">
              <span className="text-3xl font-bold gold-text block mb-2">{item.num}</span>
              <h4 className="font-bold mb-1">{item.title}</h4>
              <p className="text-sm text-[var(--text-muted)]">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
